import type { ExternalTableSchema } from '@packages/table-builder';

export const employeeTypesTable: ExternalTableSchema = {
  metadata: {
    title: 'Employee Types',
    entity: 'employee-type',
  },
  dataSource: {
    endpoint: '/api/customer/api/app/employee-type/employee-types-list',
    method: 'GET',
    rowIdField: 'id',
    responseMapping: { items: 'items', totalCount: 'totalCount' },
    queryParams: { IsTaxEnabled: 'IsTaxEnabled' },
    filters: [
      {
        field: 'IsTaxEnabled',
        type: 'select',
        label: 'Withhold Tax',
        placeholder: 'Withhold Tax',
        options: [
          { label: 'Enable', value: true },
          { label: 'Disable', value: false },
        ],
      },
    ],
  },
  columns: [
    { field: 'name', header: 'Employee Types', type: 'text', width: 250, sortable: true },
    { field: 'description', header: 'Description', type: 'text', width: 250 },
    {
      field: 'isTaxEnable',
      header: 'Withhold Tax',
      type: 'badge',
      width: 250,
      align: 'center',
      conditionalValues: { true: 'Enable', false: 'Disable' },
      badge: { statusMap: { Enable: 'success', Disable: 'error' } },
    },
  ],
  actions: {
    toolbar: {
      primary: { id: 'ADD_EMPLOYEE_TYPE', label: 'Add Employee Type', icon: 'add_circle_outline' },
    },
    row: [
      { id: 'VIEW_EMPLOYEE_TYPE', label: 'View' },
      { id: 'EDIT_EMPLOYEE_TYPE', label: 'Edit' },
      { id: 'DELETE_EMPLOYEE_TYPE', label: 'Delete', variant: 'danger' },
    ],
  },
  features: {
    search: { enabled: true, placeholder: 'Search' },
    pagination: { mode: 'infiniteScroll', defaultSize: 10 },
    columnPreferences: { persistenceKey: 'Employee Types', resizable: true, reorderable: true },
  },
};
